export default "https://cdn-static-staging.gokick.com/assets/ec0de4ab37568b9a2e84c5fbf7dadc9a5c7c6fae/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";